<template>
    <div class="container-enterprise-vertical">
        <section class="enterprise-vertical-header scroll-color-primary">
            <div :class="{ 'active-scroll': data?.towers?.length >= 10 }" class="enterprise-vertical">
                <div
                    v-for="(tower, i) in data.towers || []"
                    :key="i"
                    :class="{ active: tower.active }"
                    class="number-towers"
                    @click="loadTower(tower.number)"
                >
                    <span class="enterprise-value">{{ tower.enterprise }}</span>
                </div>
            </div>

            <div v-if="data?.towers?.length < 10" class="registered-towers">
                <span class="quantity">{{ data?.towers?.length || 0 }} torres </span>
                <span class="registered">cadastradas</span>
            </div>
        </section>

        <div v-if="data?.towers?.length >= 10" class="registered-towers-scroll">
            <span class="quantity">{{ data?.towers?.length || 0 }} torres </span>
            <span class="registered">cadastradas</span>
        </div>

        <div class="container-enterprise">
            <div v-if="loading.blocks[activeTower]" class="loader-container-enterprise">
                <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
            </div>

            <div
                v-else
                :class="{ 'scroll-color-active': activeScroll[3]?.length > 9 }"
                class="container-enterprise-scroll scroll-color"
            >
                <section
                    :class="{'hidden-border-bottom': data?.floors?.underground?.length }"
                    class="enterprise-vertical-content"
                >
                    <div
                        class="number-upper-tower"
                        :class="{
                            'border-tower': borderTower,
                            'upper-tower-after-none': lengthUnitsOverground?.units?.length <= 5
                        }"
                    >
                        <div class="hr" :class="{ 'display-none': lengthUnitsOverground?.units?.length <= 5 }" />

                        <div class="number-upper-active-tower">
                            <span class="number">Torre {{ activeTower }}</span>

                            <div class="arrow-effect-number-tower" />
                        </div>
                    </div>

                    <div class="container-base-number-towers">
                        <div
                            class="base-left-number-towers"
                        >
                            <div
                                v-for="(floor, i) in data?.floors?.overground"
                                :key="i"
                                class="number-tower"
                            >
                                <div class="arrow-effect" />

                                <span class="number">{{ floor.label }}</span>
                            </div>
                        </div>
                        <div
                            ref="base_scroll_towers"
                            class="base-number-towers scroll-color"
                            :class="{ 'is-scrolled-x': isScrolledX }"
                            @scroll="scrollHandler"
                        >
                            <div
                                v-for="(floor, i) in data?.floors?.overground"
                                :key="i"
                                class="container-number-towers"
                            >
                                <div
                                    ref="container_number_enterprise"
                                    class="container-number-enterprise"
                                    :style="{'min-width': widthContainer + 'px'}"
                                >
                                    <div
                                        v-for="(unit, index) in floor.units"
                                        :key="index"
                                        :class="{ 'all-width-enterprise': floor?.units?.length < 5 }"
                                        :style="{ 'background': unit.bg_color }"
                                        class="number-enterprise"
                                        @click="showUnit(unit)"
                                    >
                                        <span class="floors-number">
                                            {{ unit.number }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="base-tower-right"
                            :class="{ 'display-none': lengthUnitsOverground?.units?.length <= 5 }"
                        >
                            <div class="effect-right" />
                        </div>
                    </div>


                    <div
                        class="base-tower"
                        :class="{
                            'base-tower-after-none': lengthUnitsOverground?.units?.length <= 5,
                            'base-tower-after-none-four': lengthUnitsOverground?.units?.length <= 4,
                            'base-tower-after-none-two': lengthUnitsOverground?.units?.length == 2,
                            'base-tower-after-none-one': lengthUnitsOverground?.units?.length == 1
                        }"
                    >
                        <div class="upper-tower" />

                        <div class="lower-tower" />
                    </div>
                </section>

                <section
                    v-if="data?.floors?.underground?.length"
                    class="enterprise-vertical-underground"
                >
                    <div
                        class="base-left-number-towers"
                    >
                        <div
                            v-for="(floor, i) in data?.floors?.underground || []"
                            :key="i"
                            class="number-tower"
                        >
                            <div class="arrow-effect" />

                            <span class="number">{{ floor.label }}</span>
                        </div>
                    </div>

                    <div
                        ref="base_scroll_towers_underground"
                        class="base-number-towers base-number-tower-underground"
                        :class="{ 'border-base-tower': borderTower }"
                        @scroll="scrollHandlerUnderground"
                    >
                        <div
                            v-for="(floor, i) in data?.floors?.underground || []"
                            :key="i"
                            class="container-number-towers"
                        >
                            <div
                                ref="container_number_enterprise"
                                class="container-number-enterprise"
                                :style="{'min-width': widthContainer + 'px'}"
                            >
                                <div
                                    v-for="(unit, index) in floor.units"
                                    :key="index"
                                    :style="{ 'background': unit.bg_color }"
                                    class="number-enterprise"
                                    @click="showUnit(unit)"
                                >
                                    <span class="floors-number">
                                        {{ unit.number }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="base-tower-right-underground"
                        :class="{ 'display-none': lengthUnitsOverground?.units?.length <= 5 }"
                    />
                </section>
            </div>
        </div>
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

    import { mapGetters } from 'vuex'

	export default {
		name: 'ui-enterprise-vertical',

        components: { uiLoadIndicator },

        props: {
            data: {
                type: Object,
                default: () => {},
                required: false
            }
        },

        data() {
            return {
                active: false,
                activeScroll: [],
                activeDigitalValues: {
                    digitalMirror: true,
                    updatingValues: false
                },
                borderTower: false,
                isScrolledX: false,
                widthContainerEnterprise: null,
                containerNumberEnterprise: []
            }
        },

        computed: {
            ...mapGetters('product', {
                visualizationParams: 'getVisualizationParams',
                loading: 'getLoading',
                product: 'getProduct'
            }),
            /**
             * Computed property que retorna o número da torre ativa
             */
            activeTower() {
                return this.data?.towers?.find(tower => tower.active)?.number
            },
            lengthUnitsOverground() {
                return this.data?.floors?.overground.find(overground => overground.units)
            },
            widthContainer() {
                return this.widthContainerEnterprise
            }
        },

        watch: {
            widthContainerEnterprise(newValue) {
                this.widthContainerEnterprise = newValue
            }
        },

        mounted() {
            this.containerNumberEnterprise = this.$refs.container_number_enterprise

            if (this.containerNumberEnterprise) {
                this.containerNumberEnterprise.forEach(div => {
                    // Obtenha o clientWidth da div atual
                    const width = div.clientWidth
                    // Verifique se o clientWidth atual é maior que o maior clientWidth encontrado até agora
                    if (width > this.widthContainerEnterprise) {
                        // Se sim, atualize o valor de widthContainerEnterprise
                        this.widthContainerEnterprise = width
                    }
                })
            }

            this.baseScrollTower()

            const isSomeArrayGreaterThan9 = this.activeScroll.some(array => {
                return array.length > 8 ? true : false
            })

            this.isScrolledX = isSomeArrayGreaterThan9
        },

        methods: {
            scrollHandler(event) {
                event.target.scrollLeft > 10 ? this.borderTower = true : this.borderTower = false

                this.scrollHandlerUnderground()
            },
            scrollHandlerUnderground() {
                const courseDiv = this.$refs.base_scroll_towers
                const targetDiv = this.$refs.base_scroll_towers_underground

                if (targetDiv) {
                    targetDiv.scrollLeft = courseDiv.scrollLeft
                }
            },
            baseScrollTower() {
                this.activeScroll = Object.values(this.data?.floors || {})
                    .reduce((acc, floors) => acc.concat(floors), [])
                    .map(floor => floor.units)
            },
            /**
             * Seta os parâmetros de filtragem necessários para a visualização e emite o evento para
             * carregar os dados necessários
             */
            loadTower(value) {
                let params = { ...this.visualizationParams }
                params.filter = params.filter
                    ? {
                        ...params.filter,
                        blocks: value
                    }
                    : { blocks: value }
                params.header = false

                this.$store.dispatch('product/setVisualizationParams', params)
                this.$emit('load')
            },
            /**
             * Emite um evento para mostrar os dados da unidade em um modal
             */
            showUnit(unit) {
                // Não abre o modal para unidades vazias
                if (!(unit.integration_id || unit.id)) return

                // Caso o produto seja uma integração ERP, o ID da unidade será o integration_id
                let payload = {
                    id: unit.integration_id || unit.id,
                    visualization: 'digitalmirror'
                }
                if (unit.integration_id) payload.availability_id = this.product?.availability_id
                this.$root.$emit('modal-open-units-data', payload)
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>